import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { AlertService } from 'src/app/_alert';
import { AuthService } from 'src/app/_services/auth.service';
import { LoginService } from 'src/app/_services/login.service';
import { PasswordStrengthValidator } from 'src/app/Product/password-strength.validators';
import { SameEmailComponent } from 'src/app/Product/same-email/same-email.component';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {

  submitted: boolean = true;
  constructor(private router: Router,
    private loginService: LoginService,
    private authService: AuthService,
    public dialog: MatDialog,
    public alertService: AlertService
  ) { }
  displayText: string[] = [];
  ngOnInit(): void {
    this.registrationForm.get('FirstName').valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe((query: any) => {
      if (query.length >= 1 && query.length <= 4) {
        this.displayText = [' Company details will be taken in sub sequences screen!'];
        console.log(this.displayText);
      }
      else {
        this.displayText = [];
        console.log(this.displayText);
      }
    }, (err) => {
      console.log(err)
    })
  }
  hide = true;
  options = {
    autoClose: true,
    keepAfterRouteChange: true,
  };

  registrationForm: FormGroup = new FormGroup(
    {
      FirstName: new FormControl('', [Validators.required]),
      LastName: new FormControl('', [Validators.required]),
      Email: new FormControl('', [
        Validators.required,
        Validators.email,
        Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]),
      Password: new FormControl('', [
        Validators.required,
        Validators.minLength(6),
        PasswordStrengthValidator
      ]),
      IsActive: new FormControl(false),
      UserType: new FormControl('User'),
      CreatedBy: new FormControl(''),
      CustomerId: new FormControl('')
    }
  )

  register() {
    this.submitted = true;
    if (this.registrationForm.valid) {
      this.registrationForm.value.CreatedBy = this.registrationForm.value.Email;
      this.loginService.register(this.registrationForm.value)
        .subscribe((response: any) => {
          this.alertService.success('Success!! User Created SuccessFully.', this.options);
          this.authService.setRegistredUserDetails(response);
          setTimeout(() => {
            this.router.navigate(['/signin']);
          }, 2000);
        }, (err) => {
          console.log(err);
          this.alertService.error(err.error.errors.Messages[0], this.options);
        })
    }
    else {
      console.log('please enter valid details');
      this.alertService.error('Error!!Please enter valid details .', this.options);
    }
  }

  get forms() { return this.registrationForm.controls; }


}
